import React from 'react';

/** Button label that rolls up on hover, revealing an inverted copy from below. */
export function FillLabel({
  children
}: {
  children: string;
}) {
  return <span className="btn-label" data-label={children} data-id="element-137" data-mp="1vmoz8b6vbk52">
      <span data-id="element-138" data-mp="20gt8j13lw49b">{children}</span>
    </span>;
}